import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  TextField,
  Paper,
  Typography,
  Grid,
  IconButton,
  CircularProgress,
} from "@mui/material";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import MainScreen from "../../Components/Navbar/MainScreen";
import { useLocation } from "react-router-dom";
import CustomTextArea from "../../Components/CustomTextArea/CustomTextArea";
import SendIcon from "@mui/icons-material/Send";
import { connect } from "react-redux";
import axios from "axios";
import AXIOS from "../../Utils/AXIOS";
import toast from "react-hot-toast";

function DocumentInteraction(props) {
  const [pdfFile, setPdfFile] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const location = useLocation();

  const [chatLoading, setChatLoading] = useState(false);
  const [questionInput, setQuestionInput] = useState("");
  const [searchDbChat, setSearchDbChat] = useState([]);
  const [isImageFile, setIsImageFile] = useState(false);

  const chatContainerRef = useRef(null);
  const lastMessageRef = useRef(null);
  useEffect(() => {
    if (lastMessageRef.current) {
      lastMessageRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [searchDbChat]);

  // Handle File Selection
  function base64ToBlob(base64, mimeType = "") {
    const byteChars = atob(base64);
    const byteNumbers = new Array(byteChars.length);
    for (let i = 0; i < byteChars.length; i++) {
      byteNumbers[i] = byteChars.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: mimeType });
  }
  function isDocOrDocxByExtension(fileName) {
    if (!fileName || typeof fileName !== "string") return false;
    const extension = fileName.split(".").pop().toLowerCase();
    return extension === "doc" || extension === "docx";
  }

  const handleFileChange = async (event) => {
    const file = event;
    if (file) {
      // if (file.type != "application/pdf") {
      setIsImageFile(file.type === "image/jpeg");
      if (isDocOrDocxByExtension(file.name)) {
        let formData = new FormData();
        formData.append("file", file);
        axios
          .post(
            "https://pdhanewala.com:9001/apis/sharepoint/docToPdf",
            formData
          )
          .then((res) => {
            const base64String = res.data.data; // make sure this is just the raw base64, no data: prefix
            const byteArray = base64String.split(",").map(Number);

            // Step 2: Create Uint8Array from that
            const uint8Array = new Uint8Array(byteArray);

            // Step 3: Create a Blob (set correct MIME type e.g., application/pdf)
            const blob = new Blob([uint8Array], { type: "application/pdf" });

            // Step 4: Create an object URL
            const url = URL.createObjectURL(blob);
            setPdfFile(url);
          });
      } else {
        const url = URL.createObjectURL(file); // Create a temporary URL
        setPdfFile(url);
      }
    } else {
      alert("Please select a valid file");
    }
  };

  useEffect(() => {
    if (location.state.FILE) {
      handleFileChange(location.state.FILE);
    }
  }, [location.state.FILE]);

  const handleSearchDb = () => {
    if (questionInput != "") {
      setChatLoading(true);

      let candidateName =
        location.state.RESPONSE.name && location.state.RESPONSE.name.length > 0
          ? location.state.RESPONSE.name[0]
          : "";
      let candidateEmail =
        location.state.RESPONSE.candidate_id &&
        location.state.RESPONSE.candidate_id.length > 0
          ? location.state.RESPONSE.candidate_id[0]
          : "";

      let param = encodeURIComponent(
        questionInput +
          " Name:" +
          candidateName +
          " Candidate_id:" +
          candidateEmail
      );

      // console.log(
      //   "sdjhfksdh",
      //   AXIOS.defaultURL +
      //     AXIOS.resume_analytics_ask +
      //     "?question=" +
      //     param
      // );
      axios
        .post(
          AXIOS.defaultURL + AXIOS.resume_analytics_ask + "?question=" + param,
          { question: questionInput },
          {
            headers: {
              Authorization: `Bearer ${props.token}`,
              "x-api-key": `${props.token}`,
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((response) => {
          setChatLoading(false);
          // console.log("djshcjhs", response.data);
          let tempSearchDbChat = [...searchDbChat];
          tempSearchDbChat.push({
            QUESTION: questionInput,
            ANSWER: response.data,
          });
          setSearchDbChat(tempSearchDbChat);
          setQuestionInput("");
        })
        .catch((err) => {
          setChatLoading(false);
          toast.error("Something went wrong");
        });
    } else {
      toast.error("Please enter job description");
    }
  };

  const formatTextToHTML = (text) => {
    // Split text based on bullet points and filter out empty lines
    const lines = text.split("• ").filter((line) => line.trim() !== "");

    return (
      <ul>
        {lines.map((line, index) => (
          <li key={index}>{line.trim()}</li>
        ))}
      </ul>
    );
  };

  return (
    <MainScreen
      sx={{
        height: "90vh", // Set MainScreen height to 90vh
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          height: "90vh", // Adjust Box height to 90vh
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Grid container spacing={2} sx={{ width: "100%", height: "90vh" }}>
          {/* Left Section - PDF Viewer */}
          <Grid item xs={0} md={6} sx={{ height: "100%", height: "92vh" }}>
            <Box
              sx={{
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                overflow: "hidden",
              }}
            >
              {pdfFile && (
                <>
                  {isImageFile ? (
                    <img
                      src={pdfFile}
                      alt="preview"
                      style={{
                        width: "100%",
                        height: "100vh",
                        objectFit: "contain",
                        border: "1px solid #ccc",
                        display: "block",
                      }}
                    />
                  ) : (
                    <iframe
                      src={pdfFile}
                      width="100%"
                      height="100%"
                      style={{ border: "1px solid #ccc" }}
                    >
                      abcd
                    </iframe>
                  )}
                </>
              )}
            </Box>
          </Grid>

          {/* Right Section - Text Input */}
          <Grid item xs={12} md={6} sx={{ height: "100%", height: "88vh" }}>
            <Paper
              elevation={3}
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                p: 2,
              }}
            >
              <Box
                sx={{ flexGrow: 1, maxHeight: "80vh", overflowY: "auto" }}
                ref={chatContainerRef}
              >
                {searchDbChat.map((val, index) => {
                  return (
                    <div
                      key={index}
                      ref={
                        index === searchDbChat.length - 1
                          ? lastMessageRef
                          : null
                      }
                    >
                      <Box
                        sx={{
                          display: "flex", // Ensures alignment works properly
                          justifyContent: "flex-end", // Aligns to the right
                        }}
                      >
                        <Box
                          sx={{
                            backgroundColor: "#f8f9fa", // Light gray background
                            borderRadius: "10px", // Rounded corners
                            padding: "10px 15px", // Internal spacing
                            margin: "10px 0", // Spacing between questions
                            boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)", // Soft shadow
                            color: "#333", // Dark text for contrast
                            maxWidth: "60%", // Prevents full-width stretch
                            textAlign: "left", // Keeps text aligned naturally
                          }}
                        >
                          <p
                            style={{
                              margin: 0,
                              fontSize: "16px",
                              lineHeight: "1.5",
                            }}
                          >
                            {val.QUESTION}
                          </p>
                        </Box>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                        }}
                      >
                        <Box
                          sx={{
                            backgroundColor: "#f8f9fa", // Light gray background
                            borderRadius: "10px", // Rounded corners
                            padding: "10px 15px", // Internal spacing
                            margin: "10px 0", // Spacing between questions
                            boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)", // Soft shadow
                            color: "#333", // Dark text for contrast
                            maxWidth: "80%", // Prevents full-width stretch
                            textAlign: "left", // Keeps text aligned naturally
                          }}
                        >
                          {formatTextToHTML(val.ANSWER.answer)}
                        </Box>
                      </Box>
                    </div>
                  );
                })}
              </Box>

              <Box sx={{ p: 1 }}>
                {/* <TextField
                  label="Ask your question..."
                  variant="outlined"
                  fullWidth
                  value={inputValue}
                  onChange={(e) => setInputValue(e.target.value)}
                /> */}
                <Box
                  sx={{ pl: 2, pr: 2, display: "flex", alignItems: "center" }}
                >
                  <CustomTextArea
                    label="Ask any Question"
                    multiline
                    rows={1} // Number of visible rows
                    fullWidth
                    variant="outlined"
                    margin="normal"
                    value={questionInput}
                    onChange={(e) => {
                      setQuestionInput(e.target.value);
                    }}
                    onKeyDown={(e) => {
                      // If only Enter is pressed (without Shift or Ctrl)
                      if (e.key === "Enter" && !e.shiftKey && !e.ctrlKey) {
                        e.preventDefault(); // Prevent newline
                        handleSearchDb(); // Trigger submit
                      }
                    }}
                  />
                  <IconButton
                    color="primary"
                    sx={{ ml: 1, color: "#14bc9a" }}
                    onClick={() => {
                      handleSearchDb();
                    }}
                  >
                    {chatLoading ? (
                      <CircularProgress
                        color="success"
                        size={"25px"}
                        sx={{
                          color: "#14bc9a",
                        }}
                      />
                    ) : (
                      <SendIcon />
                    )}
                  </IconButton>
                </Box>
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Box>
    </MainScreen>
  );
}

const mapStateToProps = (state) => ({
  token: state.auth.token,
});

export default connect(mapStateToProps)(DocumentInteraction);
